import { render, staticRenderFns } from "./PersonalV2.vue?vue&type=template&id=e071fb82"
import script from "./PersonalV2.vue?vue&type=script&lang=js"
export * from "./PersonalV2.vue?vue&type=script&lang=js"
import style0 from "./PersonalV2.vue?vue&type=style&index=0&id=e071fb82&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports